import React, { useRef, useEffect, useState } from "react";
import "./style.scss";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { Carousel } from "../../dynamic/Carousel/Carousel";
import { debounce } from "../../helpers/utils";

interface slide {
  backgroundImage: string;
  linkText: string;
  linkUrl: string;
  headline: string;
  linkTarget?: string | null;
  target?: string | null;
}

const itemsToDisplay = { DESKTOPXL: 1, DESKTOP: 1, TABLET: 1, MOBILE: 1 };

const Slides = ({
  slides,
  page,
  maxHeight
}: {
  page: number;
  slides: slide[];
  maxHeight: number;
}) => {
  let itemsPerPage = 1;
  const slicedItems = slides.slice(
    page * itemsPerPage,
    (page + 1) * itemsPerPage
  );

  return (
    <ReactCSSTransitionGroup
      transitionName="carousel__animation"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
      style={{ maxHeight }}
      className={`carousel__animation`}
    >
      {slicedItems.map(tile => (
        <div key={tile.backgroundImage} className="grid-column__tile">
          <a
            href={tile.linkUrl}
            target={tile.target || tile.linkTarget || ""}
            className="grid-column__tile-image"
            style={{ backgroundImage: `url("${tile.backgroundImage}")` }}
          >
            <h6>{tile.headline}</h6>
          </a>
          {tile.linkText ? (
            <a
              className="grid-column__tile-cta"
              href={tile.linkUrl}
              target={tile.target || tile.linkTarget || ""}
            >
              {tile.linkText}
            </a>
          ) : null}
        </div>
      ))}
    </ReactCSSTransitionGroup>
  );
};

export const HeadlineImagesCarousel = ({ slides }: { slides: slide[] }) => {
  const carouselRef: any = useRef(null);

  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    if (carouselRef) {
      const dimensions = {
        width: carouselRef.current.children[0].offsetWidth
      };
      setHeight(dimensions.width * 0.8);
      debounce({
        delay: 300,
        func: () => {
          const dimensions = {
            width: carouselRef.current.children[0].offsetWidth
          };
          if (carouselRef.current) {
            setHeight(dimensions.width * 0.8);
          }
        }
      });
    }
  }, []);

  return (
    <div
      ref={carouselRef}
      className="homepage-hero-grid homepage-hero-grid__carousel-container growing-the-game"
    >
      <Carousel
        isPagerFullWidth
        totalItems={slides.length}
        itemsToDisplay={itemsToDisplay}
        pagerPerItem={true}
      >
        <Slides slides={slides} page={0} maxHeight={height} />
      </Carousel>
    </div>
  );
};

const GrowingTheGame = ({ slides }: { slides: slide[] }) => {
  return (
    <>
      <section className="page-section hide--mobile">
        <div className={`grid-column__container container`}>
          <h2>Growing the game</h2>
          <div className="grid-column__tiles">
            {slides.map(tile => (
              <div className="grid-column__tile">
                <a
                  href={tile.linkUrl}
                  target={tile.target || tile.linkTarget || ""}
                  className="grid-column__tile-image"
                  style={{ backgroundImage: `url("${tile.backgroundImage}")` }}
                >
                  <h6>{tile.headline}</h6>
                </a>
                {tile.linkText ? (
                  <a
                    className="grid-column__tile-cta"
                    href={tile.linkUrl}
                    target={tile.target || tile.linkTarget || ""}
                  >
                    {tile.linkText}
                  </a>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="hide--tablet hide--desktop container">
        <HeadlineImagesCarousel slides={slides} />
      </section>
    </>
  );
};

export default GrowingTheGame;
